




















import Vue from "vue";

import IconRadioTT4WChecked from "../../assets/icons/misc/TT4WRadioChecked.svg";
import IconRadioTT4WUnchecked from "../../assets/icons/misc/TT4WRadio.svg";

interface Props {
  checked: boolean;
  description: string;
  iconChecked: string;
  iconUnchecked: string;
}

export default Vue.extend<Props>({
  name: "JzInputRadio",
  functional: true,

  props: {
    checked: { type: Boolean, required: true },
    description: { type: String, default: "" },
    iconChecked: { type: String, default: IconRadioTT4WChecked },
    iconUnchecked: { type: String, default: IconRadioTT4WUnchecked }
  }
});
